import {
  Box,
  Button,
  Flex,
  NumberInput,
  ScrollArea,
  Table,
  Text,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { memo, useCallback, useEffect, useState } from "react";
import cx from "clsx";
import classes from "../../../../Styles/TableScrollArea.module.css";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

interface Products {
  quantity: number;
  weight: number;
  product_code: string;
  name: string;
}

interface ProductRowProps {
  item: Products;
  onUpdateWeight: (
    id: string,
    field: "weight" | "weightPackage",
    value: number,
  ) => void;
  isCOD?: boolean;
}

const ProductRow = memo(({ item, onUpdateWeight }: ProductRowProps) => {
  return (
    <Table.Tr>
      <Table.Td w={100}>{item.product_code}</Table.Td>
      <Table.Td>{item.name}</Table.Td>
      <Table.Td w={100}>{item.quantity}</Table.Td>
      <Table.Td w={300}>
        <Flex align="center" gap={10}>
          <Text size="11.5px">Khối lượng thực tế</Text>
          <NumberInput
            placeholder="Khối lượng thực tế"
            value={item.weight}
            // Gọi hàm cập nhật cho weight
            onChange={(val) =>
              onUpdateWeight(item.product_code, "weight", Number(val))
            }
            hideControls
            allowNegative={false}
            suffix=" kg"
            size="xs"
          />
        </Flex>
      </Table.Td>
    </Table.Tr>
  );
});

const ModalTotalBoxGHTK = ({
  onSuccess,
  dataProducts,
}: {
  onSuccess: any;
  dataProducts: any[];
}) => {
  const [scrolled, setScrolled] = useState(false);

  const [totalBox, setTotalBox] = useState<number>(1);
  const [dataProductUpdateWeight, setDataProductUpdateWeight] = useState<
    Products[]
  >([]);

  const customHeightTable = () => {
    if (dataProductUpdateWeight.length <= 1 || !dataProductUpdateWeight) {
      return 110;
    } else if (dataProductUpdateWeight.length === 2) {
      return 150;
    } else if (dataProductUpdateWeight.length === 3) {
      return 190;
    } else if (dataProductUpdateWeight.length === 4) {
      return 230;
    } else {
      return 270;
    }
  };

  const handleUpdateWeight = useCallback(
    (id: string, field: "weight" | "weightPackage", value: number) => {
      setDataProductUpdateWeight((prevData) =>
        prevData.map((item) => {
          if (item.product_code === id) {
            const numValue = Number(value) || 0;

            if (field === "weight") {
              return {
                ...item,
                weight: numValue,
              };
            }

            return { ...item, [field]: value };
          }
          return item;
        }),
      );
    },
    [],
  );

  const getDataProductWeight = async () => {
    let url = "/api/v1/TblItem/get-attribute54-by-item-codes";

    if (dataProducts && dataProducts.length > 0) {
      url += "?" + dataProducts.map((i) => `ItemCodes=${i.itemCode}`).join("&");
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data;

      const products = dataProducts.map((item) => ({
        quantity: Number(item.primaryQuantity),
        weight:
          Number(
            data.find((i: any) => i.itemCode === item.itemCode)?.attribute54,
          ) / 1000 || 0.1,
        product_code: item.itemId,
        name: item.itemName,
      }));

      setDataProductUpdateWeight(products);
    }
  };

  useEffect(() => {
    getDataProductWeight();
  }, [dataProducts]);

  return (
    <Box pt={10}>
      <NumberInput
        label="Số kiện hàng"
        placeholder="Nhập số kiện hàng"
        allowNegative={false}
        min={1}
        value={totalBox}
        onChange={(e) => setTotalBox(Number(e))}
        error={totalBox < 1 && "Số kiện hàng phải lớn hơn 1 !"}
        withAsterisk
      />
      <ScrollArea
        h={customHeightTable()}
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      >
        <Table
          striped
          highlightOnHover
          withTableBorder
          withColumnBorders
          mt={10}
        >
          <Table.Thead
            className={cx(classes.header, {
              [classes.scrolled]: scrolled,
            })}
          >
            <Table.Tr>
              <Table.Th>ID sản phẩm</Table.Th>
              <Table.Th>Tên sản phẩm</Table.Th>
              <Table.Th>Số lượng</Table.Th>
              <Table.Th>Khối lượng (kg)</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {dataProductUpdateWeight && dataProductUpdateWeight.length > 0 ? (
              dataProductUpdateWeight.map((i: Products) => (
                <ProductRow
                  key={i.product_code}
                  item={i}
                  onUpdateWeight={handleUpdateWeight}
                />
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={4} ta={"center"}>
                  Không tìm thấy sản phẩm !
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </ScrollArea>
      <Flex justify={"center"} align={"center"} mt={10}>
        <Button
          leftSection={<IconCheck size={18} />}
          onClick={() => {
            if (
              dataProductUpdateWeight.some((i) => !i.weight || i.weight <= 0)
            ) {
              NotificationExtension.Fails(
                "Vui lòng nhập đầy đủ khối lượng cho các sản phẩm !",
              );
            } else {
              onSuccess("LOCK", true, totalBox, dataProductUpdateWeight);
              modals.closeAll();
            }
          }}
        >
          Hoàn thành
        </Button>
      </Flex>
    </Box>
  );
};

export default ModalTotalBoxGHTK;
